<template>
	<div class="w-full mx-auto border-t-2 border-dimmed/30 max-w-container" />
</template>
